import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TableAction } from "@app/shared/model/action.model";

@Component({
    selector: "table-custom-action-overflow",
    template: `<button *ngFor="let action of actionList" mat-stroked-button class="action-btn" (click)="emitTableAction($event, action)">
        {{ action.title }}
    </button>`,
    styles: [".action-btn { text-transform: capitalize; }"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCustomActionOverflowComponent {
    @Input() actionList: TableAction[] = [];

    emitTableAction($event, action: TableAction) {
        $event?.stopPropagation();
        if (typeof action.emitAction === "function") {
            action.emitAction();
        }
    }
}
